import React from "react";

// ─── Shared pot ───────────────────────────────────────────────────────────────
function Pot({ cx }) {
  return (
    <>
      <rect fill="#AD6E55" x={cx - 18} y={218} width={36} height={7} rx={2}/>
      <path fill="#C4856A" d={`M${cx-15} 225 Q${cx-19} 237 ${cx-18} 247 L${cx+18} 247 Q${cx+19} 237 ${cx+15} 225 Z`}/>
      <rect fill="#965840" x={cx - 23} y={247} width={46} height={7} rx={3}/>
      <rect fill="#7A4A30" x={cx - 17} y={218} width={34} height={4} rx={1}/>
    </>
  );
}

// ─── Trunk paths shared across all stages ────────────────────────────────────
function Trunk({ cx, strokeColor = "#A0673A" }) {
  return (
    <>
      <path fill="none" stroke={strokeColor} strokeWidth={10} strokeLinecap="round" strokeLinejoin="round"
        d={`M${cx} 218 Q${cx-4} 192 ${cx-8} 166 Q${cx-11} 144 ${cx-9} 122 Q${cx-7} 103 ${cx-5} 84`}/>
      <path fill="none" stroke={strokeColor} strokeWidth={5.5} strokeLinecap="round"
        d={`M${cx-8} 152 Q${cx-26} 140 ${cx-42} 131`}/>
      <path fill="none" stroke={strokeColor} strokeWidth={5.5} strokeLinecap="round"
        d={`M${cx-7} 160 Q${cx+10} 147 ${cx+25} 138`}/>
      <path fill="none" stroke={strokeColor} strokeWidth={3.5} strokeLinecap="round"
        d={`M${cx-7} 122 Q${cx-22} 109 ${cx-34} 99`}/>
      <path fill="none" stroke={strokeColor} strokeWidth={3.5} strokeLinecap="round"
        d={`M${cx-6} 114 Q${cx+8} 101 ${cx+20} 91`}/>
      <path fill="none" stroke={strokeColor} strokeWidth={2.5} strokeLinecap="round"
        d={`M${cx-5} 84 Q${cx-6} 68 ${cx-7} 54`}/>
    </>
  );
}

// ─── Stage 1 — Almost bare ────────────────────────────────────────────────────
function Stage1({ cx = 170 }) {
  return (
    <g>
      <path fill="none" stroke="#A0673A" strokeWidth={8} strokeLinecap="round"
        d={`M${cx} 218 Q${cx-3} 198 ${cx-6} 178 Q${cx-8} 160 ${cx-6} 144 Q${cx-4} 132 ${cx-2} 120`}/>
      <path fill="none" stroke="#A0673A" strokeWidth={3} strokeLinecap="round"
        d={`M${cx-6} 158 Q${cx-18} 150 ${cx-28} 144`}/>
      <path fill="none" stroke="#A0673A" strokeWidth={3} strokeLinecap="round"
        d={`M${cx-5} 164 Q${cx+8} 156 ${cx+18} 150`}/>
      <path fill="none" stroke="#A0673A" strokeWidth={2} strokeLinecap="round"
        d={`M${cx-2} 120 Q${cx-3} 108 ${cx-4} 97`}/>

      {/* Just 4 tiny sparse clusters */}
      <ellipse fill="#96B89A" cx={cx-4} cy={90} rx={13} ry={10}/>
      <ellipse fill="#B8D4B0" cx={cx-10} cy={86} rx={8} ry={6}/>
      <ellipse fill="#96B89A" cx={cx-29} cy={138} rx={11} ry={8}/>
      <ellipse fill="#B8D4B0" cx={cx+19} cy={144} rx={10} ry={7}/>

      <Pot cx={cx}/>
    </g>
  );
}

// ─── Stage 2 — Sprouting ─────────────────────────────────────────────────────
function Stage2({ cx = 170 }) {
  return (
    <g>
      <path fill="none" stroke="#A0673A" strokeWidth={9} strokeLinecap="round" strokeLinejoin="round"
        d={`M${cx} 218 Q${cx-4} 196 ${cx-7} 172 Q${cx-10} 152 ${cx-8} 134 Q${cx-6} 118 ${cx-4} 102`}/>
      <path fill="none" stroke="#A0673A" strokeWidth={4.5} strokeLinecap="round"
        d={`M${cx-8} 153 Q${cx-24} 143 ${cx-38} 135`}/>
      <path fill="none" stroke="#A0673A" strokeWidth={4.5} strokeLinecap="round"
        d={`M${cx-7} 161 Q${cx+9} 150 ${cx+22} 142`}/>
      <path fill="none" stroke="#A0673A" strokeWidth={3} strokeLinecap="round"
        d={`M${cx-6} 122 Q${cx-18} 112 ${cx-28} 103`}/>
      <path fill="none" stroke="#A0673A" strokeWidth={3} strokeLinecap="round"
        d={`M${cx-5} 116 Q${cx+6} 106 ${cx+17} 97`}/>
      <path fill="none" stroke="#A0673A" strokeWidth={2.5} strokeLinecap="round"
        d={`M${cx-4} 102 Q${cx-5} 88 ${cx-6} 75`}/>

      <ellipse fill="#7A9E7E" cx={cx-6} cy={67} rx={20} ry={15}/>
      <ellipse fill="#96B89A" cx={cx-14} cy={62} rx={12} ry={9}/>
      <ellipse fill="#B8D4B0" cx={cx+2} cy={60} rx={10} ry={8}/>

      <ellipse fill="#7A9E7E" cx={cx-30} cy={97} rx={18} ry={13}/>
      <ellipse fill="#96B89A" cx={cx-39} cy={92} rx={11} ry={8}/>
      <ellipse fill="#B8D4B0" cx={cx-23} cy={90} rx={9} ry={6}/>

      <ellipse fill="#7A9E7E" cx={cx+19} cy={91} rx={17} ry={13}/>
      <ellipse fill="#96B89A" cx={cx+28} cy={86} rx={11} ry={8}/>

      <ellipse fill="#96B89A" cx={cx-40} cy={129} rx={15} ry={10}/>
      <ellipse fill="#B8D4B0" cx={cx-48} cy={125} rx={9} ry={6}/>
      <ellipse fill="#96B89A" cx={cx+24} cy={136} rx={14} ry={10}/>
      <ellipse fill="#B8D4B0" cx={cx+32} cy={132} rx={8} ry={6}/>

      <Pot cx={cx}/>
    </g>
  );
}

// ─── Stage 3 — Growing stronger ──────────────────────────────────────────────
function Stage3({ cx = 170 }) {
  return (
    <g>
      <Trunk cx={cx}/>
      <path fill="none" stroke="#A0673A" strokeWidth={3} strokeLinecap="round"
        d={`M${cx-42} 131 Q${cx-52} 120 ${cx-60} 111`}/>
      <path fill="none" stroke="#A0673A" strokeWidth={3} strokeLinecap="round"
        d={`M${cx+25} 138 Q${cx+35} 127 ${cx+42} 118`}/>

      <ellipse fill="#7A9E7E" cx={cx-5} cy={46} rx={26} ry={20}/>
      <ellipse fill="#96B89A" cx={cx-15} cy={40} rx={17} ry={12}/>
      <ellipse fill="#B8D4B0" cx={cx+8} cy={38} rx={14} ry={10}/>
      <ellipse fill="#C8E0C0" cx={cx-4} cy={34} rx={9} ry={7}/>

      <ellipse fill="#7A9E7E" cx={cx-36} cy={93} rx={23} ry={17}/>
      <ellipse fill="#96B89A" cx={cx-46} cy={87} rx={15} ry={11}/>
      <ellipse fill="#B8D4B0" cx={cx-28} cy={85} rx={12} ry={9}/>

      <ellipse fill="#7A9E7E" cx={cx+22} cy={86} rx={22} ry={16}/>
      <ellipse fill="#96B89A" cx={cx+13} cy={80} rx={14} ry={10}/>
      <ellipse fill="#B8D4B0" cx={cx+30} cy={79} rx={12} ry={8}/>

      <ellipse fill="#7A9E7E" cx={cx-62} cy={113} rx={19} ry={14}/>
      <ellipse fill="#96B89A" cx={cx-71} cy={108} rx={12} ry={9}/>
      <ellipse fill="#96B89A" cx={cx-53} cy={106} rx={10} ry={7}/>

      <ellipse fill="#7A9E7E" cx={cx+44} cy={120} rx={19} ry={14}/>
      <ellipse fill="#96B89A" cx={cx+53} cy={115} rx={12} ry={9}/>
      <ellipse fill="#B8D4B0" cx={cx+36} cy={113} rx={10} ry={7}/>

      <ellipse fill="#96B89A" cx={cx-44} cy={134} rx={14} ry={9}/>
      <ellipse fill="#96B89A" cx={cx+38} cy={140} rx={13} ry={9}/>

      <Pot cx={cx}/>
    </g>
  );
}

// ─── Stage 4 — Thriving ───────────────────────────────────────────────────────
function Stage4({ cx = 170 }) {
  return (
    <g>
      <Trunk cx={cx} strokeColor="#8B5A2B"/>
      <path fill="none" stroke="#8B5A2B" strokeWidth={3} strokeLinecap="round"
        d={`M${cx-42} 131 Q${cx-54} 119 ${cx-63} 109`}/>
      <path fill="none" stroke="#8B5A2B" strokeWidth={2} strokeLinecap="round"
        d={`M${cx-54} 117 Q${cx-62} 122 ${cx-70} 127`}/>
      <path fill="none" stroke="#8B5A2B" strokeWidth={3} strokeLinecap="round"
        d={`M${cx+25} 138 Q${cx+36} 126 ${cx+46} 116`}/>
      <path fill="none" stroke="#8B5A2B" strokeWidth={2} strokeLinecap="round"
        d={`M${cx+38} 122 Q${cx+46} 128 ${cx+52} 135`}/>

      {/* Full lush canopy */}
      <ellipse fill="#5C8B60" cx={cx-5} cy={44} rx={28} ry={22}/>
      <ellipse fill="#7A9E7E" cx={cx-16} cy={37} rx={18} ry={14}/>
      <ellipse fill="#96B89A" cx={cx+9} cy={35} rx={16} ry={12}/>
      <ellipse fill="#B8D4B0" cx={cx-4} cy={30} rx={11} ry={8}/>
      <ellipse fill="#C8E0C0" cx={cx-4} cy={25} rx={6} ry={5}/>

      <ellipse fill="#5C8B60" cx={cx-38} cy={88} rx={25} ry={18}/>
      <ellipse fill="#7A9E7E" cx={cx-49} cy={81} rx={16} ry={12}/>
      <ellipse fill="#96B89A" cx={cx-29} cy={79} rx={14} ry={10}/>
      <ellipse fill="#B8D4B0" cx={cx-38} cy={74} rx={9} ry={7}/>

      <ellipse fill="#5C8B60" cx={cx+24} cy={82} rx={24} ry={17}/>
      <ellipse fill="#7A9E7E" cx={cx+14} cy={76} rx={15} ry={11}/>
      <ellipse fill="#96B89A" cx={cx+33} cy={74} rx={13} ry={9}/>
      <ellipse fill="#B8D4B0" cx={cx+24} cy={69} rx={9} ry={6}/>

      <ellipse fill="#5C8B60" cx={cx-65} cy={111} rx={21} ry={15}/>
      <ellipse fill="#7A9E7E" cx={cx-74} cy={105} rx={13} ry={10}/>
      <ellipse fill="#B8D4B0" cx={cx-57} cy={103} rx={10} ry={7}/>

      <ellipse fill="#5C8B60" cx={cx+48} cy={118} rx={20} ry={15}/>
      <ellipse fill="#7A9E7E" cx={cx+57} cy={112} rx={13} ry={10}/>
      <ellipse fill="#B8D4B0" cx={cx+40} cy={110} rx={10} ry={7}/>

      <ellipse fill="#7A9E7E" cx={cx-70} cy={130} rx={15} ry={10}/>
      <ellipse fill="#96B89A" cx={cx+54} cy={138} rx={14} ry={10}/>
      <ellipse fill="#B8D4B0" cx={cx-78} cy={125} rx={8} ry={6}/>
      <ellipse fill="#B8D4B0" cx={cx+62} cy={133} rx={8} ry={6}/>

      <ellipse fill="#96B89A" cx={cx-46} cy={138} rx={13} ry={8}/>
      <ellipse fill="#96B89A" cx={cx+40} cy={144} rx={12} ry={8}/>

      <Pot cx={cx}/>
    </g>
  );
}

// ─── Main BonsaiTree component ────────────────────────────────────────────────
export default function BonsaiTree({ stage = 1, size = 280 }) {
  const cx = 170;
  const StageComponent = { 1: Stage1, 2: Stage2, 3: Stage3, 4: Stage4 }[stage] || Stage1;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 340 290"
      style={{ display: "block", margin: "0 auto" }}
    >
      <StageComponent cx={cx}/>
    </svg>
  );
}
